import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksWithoutLoginAlert.module.scss';

interface Props {
  className?: string;
  onClick: () => void;
}

const BooksWithoutLoginAlert = ({
  className,
  intl,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksWithoutLoginAlert, className);

  return (
    <div className={classes}>
      <p className={css.BooksWithoutLoginAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.withoutLoginAlertMessage1"
          values={{
            noLogin: (
              <a
                onClick={onClick}
                className={css.BooksWithoutLoginAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({ id: 'books.forms.toUserForm' })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(BooksWithoutLoginAlert);
